<div class="signup">
  <div class="signup__header animated fadeInDown">
    <div class="container my-3">
      <a routerLink="/shop">
        <img class="signup__logo" src="/assets/images/logo.svg?v={{logoVersionNumber()}}" alt="Willow Haven">
      </a>
    </div>
  </div>

  @if (isLoadingContent() || accountService.isLoading() || isWaitingResponse() || isVerifyingToken()) {
  <mat-progress-bar mode="indeterminate" value="accent"></mat-progress-bar>
  }

  @if (isLoadedMarketingValidations() || isTryingToApplyCoupon()) {
  <div class="alert position-sticky top-0 alert-success border-0 z-1020 fade show animated fadeInUp rounded-0"
    [class.animated]="!isTryingToApplyCoupon()" role="alert">
    <div class="d-flex justify-content-center align-items-center gap-3">

      @if (signupPromotionInfo()?.code && signupPromotionInfo()?.name) {
      <section
        class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row  align-items-center gap-2 gap-sm-2 gap-md-3 gap-lg-3">
        <section class="d-flex align-items-center gap-2 justify-content-center">
          <i class="fas fa-tag"></i>
          <strong>Discount successfully applied!</strong>
        </section>
        <section class="d-flex align-items-center gap-2 justify-content-center">
          <i class="fw-semibold">({{signupPromotionInfo().code}})</i>
          {{signupPromotionInfo().name}}
        </section>
        <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
          (click)="clearSignupPromotionInfo()" ngbTooltip="Change Coupon Code">
          <i class="fas fa-sync"></i>
          <a href="javascript:void(0)" class="link-color">
            Change Coupon
          </a>
        </section>
      </section>
      } @else {
      <section
        class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row  align-items-center gap-2 gap-sm-2 gap-md-3 gap-lg-3">
        <section class="d-flex align-items-center gap-2 justify-content-center">
          <i class="fas fa-tag"></i>
          <strong class="text-nowrap">Have a coupon? Apply it here:</strong>
        </section>
        <section class="d-flex align-items-center gap-3">
          <input type="text" class="form-control form-control-sm" placeholder="Coupon Code" #signupCouponCode
            (keyup.enter)="applySignupCoupon(signupCouponCode.value)">

          <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
            (click)="applySignupCoupon(signupCouponCode.value)">
            <i class="fas fa-check"></i>
            <a href="javascript:void(0)" class="link-color">
              Apply
            </a>
          </section>

          @if (signupPromotionInfoFromLS()?.code && signupPromotionInfoFromLS()?.name) {
          or

          <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
            (click)="restoreSignupInfo()">
            <i class="fas fa-times"></i>
            <a href="javascript:void(0)" class="link-color">
              Cancel
            </a>
          </section>

          }
        </section>
      </section>
      }

    </div>
  </div>
  }

  <div class="signup__body animated fadeInUp">


    <div class="signup__body__content">

      <h2 class="h2-semibold d-flex justify-content-center">
        Create Your Account
      </h2>

      <!-- Product card template (reused inside each step for direct signup) -->
      <ng-template #productCardTpl>
        @if (isDirectSignup() && directSignupProduct()) {
        <div class="direct-signup-product-card d-flex align-items-center gap-3 p-3 mb-4 animated fadeInDown">
          <img [src]="directSignupProduct()!.img"
               [alt]="directSignupProduct()!.name"
               (error)="$any($event.target).src = '/assets/images/product-placeholder.webp'"
               class="rounded direct-signup-product-card__img">
          <div>
            <p class="h6-bold mb-1">{{ directSignupProduct()!.name }}</p>
            <!-- @if (directSignupProduct()!.packages?.length) {
              <p class="mb-0 text-muted h7-regular">{{ directSignupProduct()!.packages![0].name }}</p>
            } -->
            @if (directSignupVariant()?.name || directSignupVariant()?.price) {
              <p class="mb-0 text-muted h7-regular">{{ directSignupVariant()?.name }} — <span class="h6-semibold">${{ directSignupVariant()?.price }}</span></p>
            }
            @if (directSignupProduct()!.description?.short) {
              <p class="mb-0 text-muted h7-regular mt-1" [innerHtml]="directSignupProduct()!.description.short"></p>
            }
          </div>
        </div>
        }
      </ng-template>

      <div class="container-fluid">

            <!-- Email verified confirmation (tab opened from the email link). Stays
                 visible during the whole Personal Information step. -->
            @if (showVerifiedBanner() && stepper.selectedIndex === 1) {
            <div class="alert alert-success border-0 fade show animated fadeInDown rounded-3" role="alert">
              <div class="d-flex justify-content-center align-items-center gap-2">
                <i class="fas fa-check-circle"></i>
                <span><strong>Your email has been verified!</strong> Continue creating your account.</span>
              </div>
            </div>
            }

            <!-- Email verification: waiting for the user to open the emailed link -->
            @if (verifiedInOtherTab()) {
            <section class="text-center py-5 animated fadeInUp">
              <i class="fas fa-check-circle fa-3x text-success mb-3"></i>
              <h2 class="h5-bold head-font">Email verified</h2>
              <p class="h6-regular text-secondary mt-2 mb-0">
                You verified your email in another tab.<br />
                Continue creating your account there — you can safely close this one.
              </p>
            </section>
            } @else if (verificationPending()) {
            <section class="text-center py-5 animated fadeInUp">
              <i class="fas fa-envelope-open-text fa-3x mb-3"></i>
              <h2 class="h5-bold head-font">Verify your email</h2>
              <p class="h6-regular text-secondary mt-2">
                We've sent a verification link to <strong>{{ directSignupEmail() }}</strong>.<br />
                Open it to continue creating your account. Don't forget to check your spam folder.
              </p>
              <div class="d-flex gap-3 justify-content-center align-items-center flex-wrap mt-4">
                <button type="button" class="btn btn-secondary head-font" (click)="resendVerificationEmail()"
                  [disabled]="resendCooldown() > 0 || isSendingVerification()">
                  @if (resendCooldown() > 0) {
                  Resend email ({{ resendCooldown() }}s)
                  } @else {
                  Resend email
                  }
                </button>
                <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold cursor-pointer"
                  (click)="changeVerificationEmail()">
                  <i class="fas fa-pen"></i>
                  <a href="javascript:void(0)" class="link-color">
                    Change email
                  </a>
                </section>
              </div>
            </section>
            } @else if (verificationError()) {
            <section class="text-center py-5 animated fadeInUp">
              <i class="fas fa-exclamation-circle fa-3x text-danger mb-3"></i>
              <h2 class="h5-bold head-font">
                @if (verificationError() === 'expired') {
                This verification link has expired
                } @else {
                This verification link is not valid
                }
              </h2>
              <p class="h6-regular text-secondary mt-2">
                Please start again to receive a new verification email.
              </p>
              <button type="button" class="btn btn-secondary head-font mt-3" (click)="restartSignupVerification()">
                Start again
              </button>
            </section>
            }

            <mat-stepper [linear]="true" #stepper class="animated fadeIn"
              [class.d-none]="verificationPending() || verifiedInOtherTab() || verificationError() || isVerifyingToken()">
              <!-- Delivery information -->
              <mat-step #firstStep [editable]="false" label="Delivery Info" [completed]="false">
                <ng-template matStepperIcon="edit"> 1 </ng-template>
                <ng-container *ngTemplateOutlet="productCardTpl"></ng-container>
                <app-check-address-signup [firstStep]="firstStep"
                  [isDirectSignup]="isDirectSignup()"
                  [directSignupMembershipId]="directSignupMembershipId()"
                  (deliveryAddressChanged)="deliveryAddressInformation = $event"
                  (selectedDayChanged)="deliverySelectedDay = $event"
                  (selectedTimeWindowChanged)="deliverySelectedTimeWindow = $event"
                  (deliveryOptionChanged)="deliveryOptionSelected = $event"
                  (emailChanged)="directSignupEmail.set($event)"
                  (pickupInfoChanged)="pickupInfo.set($event)"
                  (emailAlreadyInUse)="onEmailAlreadyInUse($event)"
                  (onNextStep)="continue()"
                  #checkAddressComponent>
                </app-check-address-signup>
              </mat-step>

              <!-- CSA Option (only in normal flow) -->
              @if (!isDirectSignup()) {
              <mat-step [editable]="false" label="CSA Option">
                <app-csa-option (onNextStep)="continue($event)" [list]="premiumMemberships()"></app-csa-option>
              </mat-step>
              }

              <!-- Personal information -->
              <mat-step #personalInformationStep [completed]="false" [editable]="false" label="Personal Info">
                <ng-container *ngTemplateOutlet="productCardTpl"></ng-container>
                <app-personal-information-signup [stepper]="matStepper()" [referralSource]="referralSource()"
                  [prefilledEmail]="directSignupEmail()"
                  #personalInformationComponent (formValidityChanged)="formValidityPersonalInformation = $event"
                  (personalInformationChanged)="personalInformationData = $event" (onNextStep)="createNewClient()">
                </app-personal-information-signup>
              </mat-step>

              <!-- Payment method information -->
              <mat-step #paymentMethodStep [completed]="false" [editable]="false" label="Billing Info">
                <ng-container *ngTemplateOutlet="productCardTpl"></ng-container>
                <app-payment-method-signup (formValidityChanged)="formValidityPaymentMethod = $event"
                  (out_paymentMethodCreated)="onPaymentMethodCreated()"
                  (onNextStep)="continue()" [in_selectedMembership]="deliveryOptionSelected">
                </app-payment-method-signup>
              </mat-step>

              <!-- Subscriptions (only in normal flow) -->
              @if (!isDirectSignup()) {
              <mat-step [editable]="false" label="Subscriptions">
                <app-subscriptions-signup [subscriptionCard]="subscriptionCard()"></app-subscriptions-signup>
              </mat-step>
              }

            </mat-stepper>


        <!-- FAQs -->
        <hr class="mt-5 mb-5">
        <section>

          <h3 class="h3-bold head-font text-center">
            FAQs
          </h3>

          <div ngbAccordion [closeOthers]="true">
            @for (item of faqs; track item) {
            @defer (on viewport) {
            <div ngbAccordionItem [collapsed]="true" class="border-0">
              <h2 ngbAccordionHeader>
                <button type="button" class="h6-bold fw-bold" ngbAccordionButton>
                  {{ item.question }}
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <p class="mb-0 h6-regular" [innerHTML]="sanitizeHtml(item.answer)">
                  </p>
                </div>
              </div>
            </div>
            }@placeholder {<div></div>}
            }
          </div>

        </section>

      </div>
    </div>
  </div>


</div>
